import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { QuestionService } from './question.service';

export const Ng1QuestionModule = angular
  .module('control-room.shared.services.question', [])
  .factory('crQuestionService', downgradeInjectable(QuestionService));